import Vue from 'vue';
import * as poli from 'es6-promise/auto';
//require('es6-promise/auto'); //fallback in case off.
import * as VueGoogleMaps from 'vue2-google-maps';
import {
    orderBy
} from 'lodash'; // Loading only the orderBy partial of lodash
import axios from 'axios';

// For Clusterer read : https://www.npmjs.com/package/vue2-google-maps
import GmapCluster from 'vue2-google-maps/dist/components/cluster'; // replace src with dist if you have Babel issues

let finder = function () {
    "use strict";

    // Don't continue when not on the specific template
    if (!document.getElementById('main-finder')) {
        return;
    }

    Vue.use(VueGoogleMaps, {
        load: {
            key: ajax.googlemaps_api_key,
            region: 'NL',
            language: 'NL',
        }
    });

    // Set data for distance Calculator
    Vue.component("gmap-map", VueGoogleMaps.Map);
    Vue.component('gmap-cluster', GmapCluster);
    Vue.component("gmap-marker", VueGoogleMaps.Marker);

    new Vue({
        el: '#main-finder',

        data: {
            loading: false,
            toggledObject: '', // Active object
            searchTerm: '',
            searchZipcode: '',
            searchZipcodePrevious: '',
            invalidZipcode: false,

            selectedSpecialism: '',
            selectedLocation: [],
            selectedRange: 1,

            // Ordering
            selectedOrder: "asc",
            selectedOrderBy: 'name',

            // Variables
            specialisms: ajax.specialisms, // array is observer
            locations: ajax.locations, // array is observer
            range: [1, 2, 5, 10, 15, 20, 25, 40, 50, 100],
            zoomRange: {1:16, 2:15, 5:14, 10:13, 15:12, 20:11, 25:10, 40:9, 50:8, 100:7},

            // Google Maps properties
            maps: {
                zoom: 9,
                options: {
                    mapTypeControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false
                },
                center: {
                    lat: 52.366324039935826,
                    lng: 4.881980031721263
                    
                },
                marker: ajax.theme + '/dist/img/marker.png',
                infoWindow: {
                    content: '',
                    position: null,
                    status: false,
                    current: false,
                    options: {
                        // PixelOffset negative (height of the marker)
                        pixelOffset: {
                            width: 0,
                            height: -58
                        }
                    }
                },
            }
        },

        mounted() {
            this.loading = true;
            this.boundMarkers();
        },

        computed: {
            /**
             * Returns array of all added specialisms [ [ 'name' => 'postTitle' , 'value' => postID ], [..] ]
             * @returns {*} data array
             */
            filterSpecialism() {
                return this.specialisms;
            },

            /**
             * Returns array of all filtered locations with all the data within.
             * @returns {*}
             */
            filteredLocations() {
                // Filter through Locations based on specific variables.
                let vm = this,
                    order = vm.searchZipcodePrevious ? vm.distance : vm.selectedOrder;
                
                // change level zoom if set zipcode and km range
                vm.maps.zoom = vm.searchZipcodePrevious ? vm.zoomRange[vm.selectedRange] : 9;
                
                // Filter through Specialists based on specific variables. While convering the locations to array.
                return orderBy(
                    vm.convertToArray(vm.locations).filter(vm.helperFilteredObjects),
                    [vm.selectedOrderBy],
                    [order]
                );

            },
            /**
             * Returns array of intergers for the range selector
             * @returns {*} data array
             */
            filterRange() {
                return this.range;
            }
        },

        methods: {
            /**
             * Filter locations from observer to Array
             * @param locations
             * @returns {Array}
             */
            convertToArray(locations) {
                let data = [];
                for (let location in locations) {
                    data.push(locations[location]);
                }
                return data;
            },

            /**
             * set the bounds of the map so all markers are visible
             * @type {methods}
             */
            boundMarkers() {
                let vm = this;

                
                
                vm.$refs.gmap.$mapPromise.then((map) => {
                    const bounds = new google.maps.LatLngBounds();
                    for (let marker of vm.convertToArray(vm.locations)) {
                        bounds.extend(vm.latLngToNumber(marker.position));
                    }
                    map.fitBounds(bounds);

                    // Make sure all markers are visible on the map
                    let mapZoom = map.getZoom();
                    
                    google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
                        if (mapZoom !== map.getZoom()) {
                            mapZoom = (map.getZoom() - 1);
                            map.setZoom(mapZoom);
                        }
                    });
                });
            },

            /**
             * Check to validate the zipcode if is valude true/false
             * @param zipcode
             * @returns {boolean}
             */
            validateZipcode(zipcode) {
                const regex = /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i;
                return regex.test(zipcode);
            },

            /**
             * Check if notification has to be shown ( 'this is an invalid zipcode' ).
             * @param zipcode
             * @returns {boolean}
             */
            zipCodeAlert(zipcode) {
                let vm = this;
                if (zipcode && !vm.validateZipcode(zipcode)) {
                    vm.invalidZipcode = true;
                }
            },

            /**
             * Connection with Google Geocode API, checking distances between current location (zipcode) and the location object.
             * @param zipcode
             */
            zipCode(zipcode) {
                let vm = this;
                if (vm.validateZipcode(zipcode) && zipcode !== vm.searchZipcodePrevious) {
                    vm.invalidZipcode = false;

                    // Valid ZipCode

                    // Making the zipcode not break the URL ;-)
                    zipcode = zipcode.replace(/\s+/g, '');

                    axios
                        .get('https://maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + ajax.googlemaps_api_key)
                        .then(function (response) {

                            // Check if connected
                            if (response.status !== 200) {
                                return;
                            }

                            let data = response.data,
                                currentArea;

                            // Google Validator if succeed
                            if (data.status !== 'OK') {
                                return;
                            }

                            currentArea = data.results[0];

                            
                            //console.log(currentArea);
                            //console.log(vm.selectedRange);
                            //console.log('zoom zipcode');
                            //console.log(vm.zoomRange[vm.selectedRange]);
                            //vm.boundMarkers();
                            
                            vm.helperDistanceLocations(currentArea.place_id);

                            // Center map on my location/zipcode
                            vm.maps.center = currentArea.geometry.location;
                            //vm.maps.zoom = vm.zoomRange[vm.selectedRange];

                            // Set values so it won't run again
                            vm.searchZipcodePrevious = zipcode;
                        });
                }

                // Reset markers =)
                if (vm.searchZipcodePrevious && !zipcode) {
                    vm.searchZipcodePrevious = '';
                }
            },

            /**
             * Helper function to add the distance to the location object.
             * @type {methods}
             */
            setDistance(objectId, distance) {
                let vm = this,
                    locations = vm.convertToArray(vm.locations);

                for (let i = 0; i < locations.length; i++) {
                    let location = locations[i];

                    if (parseInt(location.value) === parseInt(objectId)) {
                        locations[i].distance = distance;
                    }
                }
            },

            /**
             * Helper to filter through filtered locations and return an array of only objectId's before sending them to Google in the helperDistanceLocations function.
             * @param array
             * @returns {Array}
             */
            locationsArray(array) {
                // Array of (filtered) locations, to make an array of only ID's
                let locationsArray = [];

                array.forEach(function (location) {
                    locationsArray.push(location.value);
                });
                return locationsArray;
            },

            /**
             * Helper function where triggering the helpers setDistance and locationsArray.
             * @param placeId
             */
            helperDistanceLocations(placeId) {
                let vm = this;
                jQuery.post(
                    ajax.ajax_url, {
                        'action': 'getDistance',
                        'origins': placeId,
                        'locations': vm.locationsArray(vm.convertToArray(vm.locations)),
                    },
                    function (response) {
                        if (response) {


                            JSON.parse(response).forEach(function (item) {
                                vm.setDistance(item.id, item.km);
                            });

                        }
                    }
                );
            },

            /**
             * Filter through all objects, returns foreach object a true or false
             * @param object
             * @returns {*}
             */
            helperFilteredObjects(object) {
                // local scope vars
                let vm = this,
                    filter = [],
                    filters,
                    data = {
                        specialism: vm.selectedSpecialism,
                        term: vm.searchTerm.toLowerCase(),
                        zipcode: vm.searchZipcodePrevious,
                        range: vm.selectedRange
                    };
                //console.log(!data.term && !data.specialism && !data.zipcode);
                //vm.maps.zoom = vm.zoomRange[vm.selectedRange];
                
                //console.log(vm.selectedRange);
                //console.log('zoom');
                //console.log(vm.zoomRange[vm.selectedRange]);
                //console.log(data.term && !data.specialism && !data.zipcode);
                //console.log(!data.term && data.specialism && !data.zipcode);
                //console.log(!data.term && !data.specialism && data.zipcode);

                // No filters return all
                if (!data.term && !data.specialism && !data.zipcode) {
                    return true;
                }

                // Filter on Term
                if (data.term && !data.specialism && !data.zipcode) {
                    return object.name.toLowerCase().indexOf(data.term) !== -1;
                }

                // Filter on Specialism
                if (!data.term && data.specialism && !data.zipcode) {
                    return object.specialisms.indexOf(data.specialism) !== -1;
                }

                // Filter on the Zipcode
                if (!data.term && !data.specialism && data.zipcode) {
                    //console.log(object.distance);
                    //console.log(data.range);
                    return object.distance <= data.range;
                }

                // define filters
                filters = {
                    term: object.name.toLowerCase().indexOf(data.term) !== -1,
                    specialism: object.specialisms.indexOf(data.specialism) !== -1,
                    zipcode: object.distance <= data.range
                };

                // Filter on all filters (of a combination of such)
                for (let prop in filters) {
                    if (data[prop]) {
                        filter.push(filters[prop]);
                    }
                }

                return filter.reduce((accumulator, currentValue) => {
                    //console.log(accumulator);
                    //console.log(currentValue);
                    return accumulator && currentValue;
                });
            },

            /**
             * Force latLong to a number, since it's returned as an string
             * @param position
             * @returns {{lat: number, lng: number}}
             */
            latLngToNumber(position) {
                // Returning the GoogleMaps LatLng to a number.
                return {
                    'lat': Number(position.lat),
                    'lng': Number(position.lng)
                }
            },

            /**
             * Centering the map based on the active accordion.
             * @param latLng
             */
            centerLocation(latLng) {
                this.maps.zoom = 12;
                this.maps.center = this.latLngToNumber(latLng);
            },

            /**
             * Centering the map onclick of Accordion-toggle and Toggle class
             */
            toggleData(post) {
                this.centerLocation(post.position);
                this.toggledObject = post.value;
            },

            /**
             * Centering the map onclick of Accordion-toggle and Toggle class
             */
            toggleDataMultiple(post, i) {
                this.centerLocation(post.position);
                this.toggledObject = post.value + '-' + i;
            },

            /**
             * Return the GoogleMaps marker.
             * @returns {string|*}
             */
            getMarker() {
                return this.maps.marker;
            },

            /**
             * Returns specialism title.
             * @param value
             * @returns {*}
             */
            getSingularSpecialism(value) {
                // No value, return..
                if (!value) {
                    return;
                }

                let label,
                    array = this.specialisms.filter(function (specialism) {
                        return (specialism.value === value);
                    });

                // If no array, return right away
                if (!array) {
                    return;
                }

                for (let i = 0, j = array.length; i < j; i++) {
                    label = array[i];
                }

                return label.name;
            },

            /**
             * Building the location accordion
             * @param object
             * @returns {string}
             */
            getLocationItem(object, index) {

                // No value, return..
                if (!object) {
                    return;
                }

                if (!index) {
                    index = 0;
                }

                if (!object.contact) {
                    return false;
                }

                // Building the inner-html output.
                let html = '',
                    htmlAdres = object.address ? '<dt>' + this.contentWindow('address', object.address) + '</dt>' : '';

                // Always multiple, so `index` is required
                if (object.multiple === true) {

                    let htmlName = '',
                        htmlValues = '';

                    for (let prop in object.contact[index]) {

                        //@marcelmastel
                        //console.log(object.contact[index]);
                        //console.log(object.contact[index][prop]);

                        htmlName += object.contact[index][prop] && prop === 'label' ? '<dt>' + this.contentWindow(prop, object.contact[index][prop]) + '</dt>' : '';
                        htmlValues += object.contact[index][prop] && prop !== 'label' ? '<dt>' + this.contentWindow(prop, object.contact[index][prop]) + '</dt>' : '';
                    }

                    html += htmlName + htmlAdres + htmlValues;

                } else {

                    html += htmlAdres;
                    for (let prop in object.contact[index]) {
                        html += object.contact[index][prop] ? '<dt>' + this.contentWindow(prop, object.contact[index][prop]) + '</dt>' : '';
                    }
                }

                return html;
            },

            /**
             * Adding content to the infoWindow
             * @param marker
             * @param idx
             */
            toggleInfoWindow(marker, idx) {

                let vm = this,
                    infoWindow = vm.maps.infoWindow;

                // Position from the marker to the infoWindow
                infoWindow.position = vm.latLngToNumber(marker.position);

                vm.maps.center = infoWindow.position;

                if (marker.contact === '') {
                    return false;
                }

                // Always multiple, so `index` is required
                if (marker.multiple === true) {

                    let addressOutput = '<li>' + vm.contentWindow('address', marker.address) + '</li>';

                    for (let index in marker.contact) {
                        let htmlName = '',
                            htmlValues = '';

                        for (let property in marker.contact[index]) {
                            htmlName = marker.contact[index][property] === 'label' ? '<li>' + this.contentWindow(property, marker.contact[index][property]) + '</li>' + addressOutput : '';
                            htmlValues += marker.contact[index][property] !== 'label' ? '<li>' + this.contentWindow(property, marker.contact[index][property]) + '</li>' : '';
                        }

                        infoWindow.content += '<ul>' + htmlName + htmlValues + '</ul>';
                    }
                } else {

                    infoWindow.content = '<h3>' + marker.name + '</h3>';
                    infoWindow.content += '<ul>';
                    infoWindow.content += '<li>' + vm.contentWindow('address', marker.address) + '</li>';

                    // Loop through array of contact details
                    for (var key in marker.contact) {
                        infoWindow.content += marker.contact[0][key] ? '<li>' + vm.contentWindow(key, marker.contact[0][key]) + '</li>' : '';
                    }
                    infoWindow.content += '</ul>';
                }
                infoWindow.content += '</div></div>';

                //check if its the same marker that was selected if yes toggle
                if (infoWindow.current === idx) {
                    infoWindow.status = !infoWindow.status;
                } else {
                    infoWindow.status = true;
                    infoWindow.current = idx;
                }

                vm.selectedLocation = infoWindow.status === true ? [marker.value] : [];
            },

            /**
             * Returning any value for the accordion, infoWindow based on the location data.
             * @param string key : identifier
             * @param string value : URL / value of dataList
             */
            contentWindow(key, value) {

                // Set the infoWindow Content based on the key.
                switch (key) {
                    case 'phone':
                        // Returning output for any phone numbers and add prefix;
                        return '<i class="fa fa-phone left" aria-hidden="true"></i><a href="tel:+31' + value + '" target="_blank">+31' + value + '</a>';


                    case 'url':
                    case 'website':
                        // Returning output for any links
                        return '<i class="fa fa-link left" aria-hidden="true"></i><a href="' + value + '" target="_blank">' + value + '</a>';

                    case 'email':
                        // Returning output for E-mailaddresses
                        return '<i class="fa fa-envelope-o left" aria-hidden="true"></i><a href="mailto:' + value + '" target="_blank">' + value + '</a>';

                    case 'address':
                        // Returning output for address
                        return '<i class="fa fa-map-marker left" aria-hidden="true"></i><span class="left">' + value + '</span>';

                    case 'label':
                        // Returning output for name
                        return '<h6 class="font-weight-bold">' + value + '</h6>';

                    default:
                        // Return default;
                        return value;
                }

            },

            /**
             * Closing the infoWindow and resetting data to it defaults
             */
            closeInfoWindow() {
                // Closing the infoWindow and resetting default properties
                this.selectedLocation = [];
                this.maps.infoWindow.status = false;
                this.boundMarkers();
            }
        }
    });
};
finder();